import * as Yup from "yup";

export const validateType = {
  text: Yup.string().required("Campo requerido"),
  controlField: Yup.string().required("Campo requerido"),
  selectGet: Yup.string().required("Campo requerido"),
  file: Yup.mixed().required("Campo requerido.").nullable(),
  fileRead: Yup.mixed().required("Campo requerido.").nullable(),
  fileExcel: null,
  // fileExcel: Yup.string().required('Campo requerido'),
  number: Yup.number()
    .typeError("Eso no parece un número")
    .required("Campo requerido"),
};

export const headerListContent = [
  // {
  //   name: "referencia",
  //   label: "Nro. Referencia",
  //   type: "sticky",
  //   listHeader: [
  //     { name: "referencia", label: "Nro. Referencia" },
  //     { name: "dimNumber", label: "Nro. DIM/DEX" },
  //     {
  //       name: "canal",
  //       label: "Canal",
  //       type: "custom",
  //       builder: (value) => {
  //         return (
  //           <div
  //             className={`text-white ${value === "Canal Rojo"
  //               ? "bg-[#fd3838A1]"
  //               : value === "Canal Amarillo"
  //                 ? "bg-[#f3e40c51] text-[#747474]"
  //                 : value === "Canal Verde"
  //                   ? "bg-[#4fce4431] text-gray-500"
  //                   : "text-gray-500"
  //               } text-center rounded-full py-1 px-2`}
  //           >
  //             {value}
  //           </div>
  //         );
  //       },
  //     },
  //   ],
  // },
  // {
  //   name: "complejidad",
  //   label: "Complejidad",
  //   type: "sticky",
  //   listHeader: [
  //     {
  //       name: "prioridad",
  //       label: "Prioridad",
  //       type: "custom",
  //       builder: (value) => {
  //         return (
  //           <div
  //             className={`text-white ${value === "Alta"
  //               ? "bg-[#fd3838A1]"
  //               : value === "Media"
  //                 ? "bg-[#f3e40c51] text-[#747474]"
  //                 : value === "Baja"
  //                   ? "bg-[#4fce4421]"
  //                   : ""
  //               } text-center rounded-full w-fit py-1 px-4 `}
  //           >
  //             {value}
  //           </div>
  //         );
  //       },
  //     },
  //     { name: "complejidad", label: "Complejidad" },
  //   ],
  // },
  // {
  //   name: "tarea",
  //   label: "Tarea del día",
  //   type: "sticky",
  //   listHeader: [
  //     { name: "tarea", label: "Tarea del día" },
  //     { name: "estadoDeTarea", label: "Estado de la tarea" },
  //     { name: "fechaDeTarea", label: "Fecha de la tarea" },
  //   ],
  // },
  // { name: "observacionesDeTarea", label: "Observaciones de la tarea" },
  // { name: "complejidad", label: "Complejidad" },
  // { name: "initialDate", label: "Fecha de inicio" },
  // {
  //   name: "javestCorrelativo",
  //   label: "Correlativo",
  // },
  {
    name: "nroDeInterno",
    label: "Nro. interno",
    // type: "sticky",
    // listHeader: [
    //   {
    //     name: "nroDeInterno",
    //     label: "Nro. interno",
    //   },
    //   {
    //     name: "a1NúmeroDeDeclaración",
    //     label: "Nro declaración",
    //   },
    // ]
  },
  {
    name: "creationDate",
    label: "Fecha de inicio",
    type: "date",
  },
  {
    name: "procedureTypeName",
    label: "Tipo de flujo",
  },
  // {
  //   name: "tarea",
  //   label: "Valor FOB",
  //   type: "sticky",
  //   listHeader: [
  //     { name: "f6TotalValorFob", label: "Valor FOB" },
  //     { name: "opcionesDeProforma", label: "OPCIONES DE PROFORMA" },
  //     { name: "fondos", label: "FONDOS" },
  //   ],
  // },
  // {
  //   name: "proveedor",
  //   label: "Proveedor",
  //   type: "sticky",
  //   listHeader: [
  //     { name: "proveedor", label: "Proveedor" },
  //     { name: "facturaComercial", label: "Factura Comercial" },
  //   ],
  // },
  // {
  //   name: "empresaDeTransporte",
  //   label: "Empresa de Transporte",
  //   type: "sticky",
  //   listHeader: [
  //     { name: "empresaDeTransporte", label: "Empresa de Transporte" },
  //     { name: "nroEmbarque", label: "Nro. de embarque" },
  //   ],
  // },
  { name: "stepDetail", label: "Paso actual" },
  {
    name: "a4AduanaDeDespacho",
    label: "Aduana",
    type: "sticky",
    listHeader: [
      { name: "a4AduanaDeDespacho", label: "Aduana" },
      {
        name: "régimen/PatrónImportación",
        label: "Regimen/Patrón",
        type: "custom",
        builder: (value) => {
          return (
            <div
              className={`text-white ${value === "IMA4 DESPACHO ANTICIPADO IMP A CONSUMO" ||
                value === "IMI4 DESPACHO INMEDIATO IMP A CONSUMO"
                ? "text-red-500"
                : "text-gray-500"
                } text-center rounded-full py-1 px-2`}
            >
              {value}
            </div>
          );
        },
      },
    ],
  },
  { name: "descripciónDeLaMercancía", label: "Mercadería" },

  // { name: "estadoRecojo", label: "Estado de recojo" },
  // {
  //   name: "estadoArribo",
  //   label: "Estado de arribo",
  //   type: "sticky",
  //   listHeader: [
  //     { name: "estadoArribo", label: "Estado de arribo" },
  //     { name: "estadoArriboObs", label: "Observaciones de arribo" }
  //   ],
  // },
  // { name: "estadoPago", label: "Estado de pago" },
  // { name: "gestorAsignado", label: "Gestor" },
  { name: "designacionDeLiquidador", label: "Liquidador" },
  // { name: "encargadoTramite", label: "Encargado" },

  // {
  //   name: "almacen",
  //   label: "Almacén",
  //   type: "sticky",
  //   listHeader: [
  //     { name: "almacen", label: "Almacén" },
  //     { name: "montoAlmacenaje", label: "Monto de Almacenaje" },
  //   ],
  // },
  // // { name: "nextStep", label: "Progreso" },
  // { name: "transportista", label: "Transportista" },
  // { name: "diasAbandono", label: "Días restantes abandono" },
  // {
  //   name: "fechaRetiroMercaderia",
  //   label: "Retiro de Mercadería",
  //   type: "sticky",
  //   listHeader: [
  //     { name: "fechaRetiroMercaderia", label: "Retiro de Mercadería" },
  //     { name: "fechaEntregaMercaderia", label: "Entrega de Mercadería" },
  //     {
  //       name: "fechaEnvioDocumentosCliente",
  //       label: "Envió de documentos cliente",
  //     },
  //   ],
  // },
];
export const headerListFiscalizationContent = [
  {
    name: "referencia",
    label: "Nro. Referencia",
    type: "sticky",
    listHeader: [
      { name: "referencia", label: "Nro. Referencia" },
      { name: "dimNumber", label: "Nro. DIM/DEX" },
      {
        name: "canal",
        label: "Canal",
        type: "custom",
        builder: (value) => {
          return (
            <div
              className={`text-white ${value === "Canal Rojo"
                ? "bg-[#fd3838A1]"
                : value === "Canal Amarillo"
                  ? "bg-[#f3e40c51] text-[#747474]"
                  : value === "Canal Verde"
                    ? "bg-[#4fce4431] text-gray-500"
                    : "text-gray-500"
                } text-center rounded-full py-1 px-2`}
            >
              {value}
            </div>
          );
        },
      },
    ],
  },
  {
    name: "complejidad",
    label: "Complejidad",
    type: "sticky",
    listHeader: [
      {
        name: "prioridad",
        label: "Prioridad",
        type: "custom",
        builder: (value) => {
          return (
            <div
              className={`text-white ${value === "Alta"
                ? "bg-[#fd3838A1]"
                : value === "Media"
                  ? "bg-[#f3e40c51] text-[#747474]"
                  : value === "Baja"
                    ? "bg-[#4fce4421]"
                    : ""
                } text-center rounded-full w-fit py-1 px-4 `}
            >
              {value}
            </div>
          );
        },
      },
      { name: "complejidad", label: "Complejidad" },
    ],
  },

  {
    name: "tarea",
    label: "Tarea del día",
    type: "sticky",
    listHeader: [
      { name: "tarea", label: "Tarea del día" },
      { name: "estadoDeTarea", label: "Estado de la tarea" },
    ],
  },
  { name: "observacionesDeTarea", label: "Observaciones de la tarea" },
  // { name: "complejidad", label: "Complejidad" },
  { name: "initialDate", label: "Fecha de inicio" },
  {
    name: "proveedor",
    label: "Proveedor",
    type: "sticky",
    listHeader: [
      { name: "proveedor", label: "Proveedor" },
      { name: "facturaComercial", label: "Factura Comercial" },
    ],
  },
  {
    name: "empresaDeTransporte",
    label: "Empresa de Transporte",
    type: "sticky",
    listHeader: [
      { name: "empresaDeTransporte", label: "Empresa de Transporte" },
      { name: "nroEmbarque", label: "Nro. de embarque" },
    ],
  },
  { name: "stepDetail", label: "Paso actual" },
  {
    name: "aduana",
    label: "Aduana",
    type: "sticky",
    listHeader: [
      { name: "aduana", label: "Aduana" },
      {
        name: "regimenPatron",
        label: "Regimen/Patrón",
        type: "custom",
        builder: (value) => {
          return (
            <div
              className={`text-white ${value === "IMA4 DESPACHO ANTICIPADO IMP A CONSUMO" ||
                value === "IMI4 DESPACHO INMEDIATO IMP A CONSUMO"
                ? "text-red-500"
                : "text-gray-500"
                } text-center rounded-full py-1 px-2`}
            >
              {value}
            </div>
          );
        },
      },
    ],
  },
  { name: "descripcionMercancia", label: "Mercadería" },

  { name: "estadoRecojo", label: "Estado de recojo" },
  {
    name: "estadoArribo",
    label: "Estado de arribo",
    type: "sticky",
    listHeader: [
      { name: "estadoArribo", label: "Estado de arribo" },
      { name: "estadoArriboObs", label: "Observaciones de arribo" }
    ],
  },
  { name: "estadoPago", label: "Estado de pago" },
  { name: "gestorAsignado", label: "Gestor" },
  { name: "liquidadorAsignado", label: "Liquidador" },
  { name: "encargadoTramite", label: "Encargado" },

  {
    name: "almacen",
    label: "Almacén",
    type: "sticky",
    listHeader: [
      { name: "almacen", label: "Almacén" },
      { name: "montoAlmacenaje", label: "Monto de Almacenaje" },
    ],
  },
  // { name: "nextStep", label: "Progreso" },
  { name: "transportista", label: "Transportista" },
  {
    name: "fechaRetiroMercaderia",
    label: "Retiro de Mercadería",
    type: "sticky",
    listHeader: [
      { name: "fechaRetiroMercaderia", label: "Retiro de Mercadería" },
      { name: "fechaEntregaMercaderia", label: "Entrega de Mercadería" },
      {
        name: "fechaEnvioDocumentosCliente",
        label: "Envió de documentos cliente",
      },
    ],
  },
];

export const headerList = [
  {
    name: "codigoDeInterno",
    label: "Nro. Trazo",
    type: "sticky",
    listHeader: [
      { name: "codigoDeInterno", label: "Nro. Trazo" },
      { name: "razonSocial", label: "Cliente" },
    ],
  },
  ...headerListContent,
];

export const headerClientList = [
  { name: "companyName", label: "Cliente" },
  { name: "internCode", label: "Nro. Trazo" },
  { name: "referencia", label: "Nro. Referencia" },
  { name: "dimNumber", label: "Nro. DIM/DEX" },
  { name: "stepDetail", label: "Paso actual" },
];

export const mapIcons = (label) => {
  switch (label) {
    case 'Validado':
    case 'approved':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-7 w-7 text-green-500"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clipRule="evenodd"
          />
        </svg>
      )
    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-7 w-7 text-red-500"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clipRule="evenodd"
          />
        </svg>
      )
  }
}

export const headerQuotationList = [
  // {
  //   name: "internCode",
  //   label: "Nro. Cotización",
  //   type: "sticky",
  //   listHeader: [
  //     { name: "nroQuotation", label: "Nro. cotización" },
  //     { name: "companyName", label: "Cliente" },
  //   ],
  // },
  { name: "nroQuotation", label: "Nro. cotización" },
  {
    name: "internCode",
    label: "Nro. Trazo",
    type: "sticky",
    listHeader: [
      { name: "internCode", label: "Nro. Trazo" },
      { name: "companyName", label: "Cliente" },
    ],
  },
  { name: "estadoCotizacion", label: "Estado de cotización" },
  // ...headerListContent,
];

export const filtersDefaultChart = [
  {
    name: "procedureType",
    url: "/procedureType",
    default: "Todos los tramites",
    valueOption: "id",
    labelOption: "name",
  },
  {
    name: "liquidator",
    url: "/Dropdown/rol_liquidator/options",
    label: "Todos los liquidadores",
    valueOption: "name",
    labelOption: "name",
  },
  {
    name: "gestor",
    url: "/Dropdown/rol_gestor/options",
    label: "Todos los gestores",
    valueOption: "name",
    labelOption: "name",
  },
  {
    name: "inCharge",
    url: "/Dropdown/rol_InCharge/options",
    label: "Todos los encargados",
    valueOption: "id",
    labelOption: "name",
  },
  {
    name: "prioridad",
    url: "/Dropdown/prioridad/options",
    label: "Prioridad",
    valueOption: "name",
    labelOption: "name",
  },
  {
    name: "complejidad",
    url: "/Dropdown/ComplejidadDelDespacho/options",
    label: "Complejidad",
    valueOption: "name",
    labelOption: "name",
  },
  {
    name: "dateQuery",
    label: "Filtrar fecha por: ",
    options: [
      {
        label: "Fecha de facturación",
        name: "fechaDeFacturación",
      },
      {
        label: "Fecha aceptación",
        name: "a2FechaDeAceptación",
      },
      {
        label: "Fecha de inicio",
        name: "procFechaInicio",
      },
    ],
  },
  {
    name: "months",
    label: "Todos los meses",
    options: [
      {
        label: "Enero",
        name: "1",
      },
      {
        label: "Febrero",
        name: "2",
      },
      {
        label: "Marzo",
        name: "3",
      },
      {
        label: "Abril",
        name: "4",
      },
      {
        label: "Mayo",
        name: "5",
      },
      {
        label: "Junio",
        name: "6",
      },
      {
        label: "Julio",
        name: "7",
      },
      {
        label: "Agosto",
        name: "8",
      },
      {
        label: "Septiembre",
        name: "9",
      },
      {
        label: "Octubre",
        name: "10",
      },
      {
        label: "Noviembre",
        name: "11",
      },
      {
        label: "Diciembre",
        name: "12",
      },
    ],
  },
];
export const filtersDefaultChartAmount = [
  {
    name: "procedureType",
    url: "/procedureType",
    default: "Todos los tramites",
    valueOption: "id",
    labelOption: "name",
  },
  {
    name: "liquidator",
    url: "/Dropdown/rol_liquidator/options",
    label: "Todos los liquidadores",
    valueOption: "name",
    labelOption: "name",
  },
  {
    name: "gestor",
    url: "/Dropdown/rol_gestor/options",
    label: "Todos los gestores",
    valueOption: "name",
    labelOption: "name",
  },
  {
    name: "inCharge",
    url: "/Dropdown/rol_InCharge/options",
    label: "Todos los encargados",
    valueOption: "id",
    labelOption: "name",
  },
  {
    name: "prioridad",
    url: "/Dropdown/prioridad/options",
    label: "Prioridad",
    valueOption: "name",
    labelOption: "name",
  },
  {
    name: "complejidad",
    url: "/Dropdown/ComplejidadDelDespacho/options",
    label: "Complejidad",
    valueOption: "name",
    labelOption: "name",
  },
  {
    name: "dateQuery",
    label: "Filtrar fecha por: ",
    options: [
      {
        label: "Fecha de facturación",
        name: "fechaDeFacturación",
      },
      {
        label: "Fecha aceptación",
        name: "a2FechaDeAceptación",
      },
      {
        label: "Fecha de inicio",
        name: "procFechaInicio",
      },
    ],
  },
];

export const filtersDefault = [
  {
    name: "companyId",
    url: "/company/getallcompanies",
    label: "Todas las compañías",
    valueOption: "id",
    labelOption: "razonSocial",
  },
  {
    name: "ConcatYears",
    default: "",
    label: "Gestión",
    type: "multiSelect",
    defaultValue: { value: '2026', label: '2026' },
    options: [
      {
        label: "2026",
        name: "2026",
        initial: true,
      },
      {
        label: "2025",
        name: "2025",
      },
      {
        label: "2024",
        name: "2024",
      },
      {
        label: "2023",
        name: "2023",
      },
      {
        label: "2022",
        name: "2022",
      },
      {
        label: "2021",
        name: "2021",
      },
      {
        label: "2020",
        name: "2020",
      },
      {
        label: "2019",
        name: "2019",
      },
    ],
  },
  // {
  //   name: "liquidator",
  //   url: "/Dropdown/rol_liquidator/options",
  //   label: "Todos los liquidadores",
  //   valueOption: "name",
  //   labelOption: "name",
  //   aditionalOptions: [{ label: "*NO ASIGNADOS*", value: "-" }]
  // },
  // {
  //   name: "gestor",
  //   url: "/Dropdown/rol_gestor/options",
  //   label: "Todos los gestores",
  //   valueOption: "name",
  //   labelOption: "name",
  // },
  // {
  //   name: "inCharge",
  //   url: "/Dropdown/rol_InCharge/options",
  //   label: "Todos los encargados",
  //   valueOption: "id",
  //   labelOption: "name",
  // },
  // {
  //   name: "inCharges",
  //   url: "/Dropdown/rol_InCharge/options",
  //   label: "Todos los encargados",
  //   type: "multiSelect",
  //   valueOption: "id",
  //   labelOption: "name",
  // },
  // {
  //   name: "status",
  //   label: "Todos los tramites",
  //   options: [
  //     {
  //       label: "Pendientes",
  //       name: "pendiente",
  //       initial: true,
  //     },
  //     {
  //       label: "Transmitido",
  //       name: "transmitido",
  //     },
  //     {
  //       label: "Retirados",
  //       name: "retirado",
  //     },
  //   ],
  // },
  // {
  //   name: "status",
  //   label: "Estado de trámites",
  //   type: "multiSelect",
  //   // defaultValue: { value: 'pendiente', label: 'Pendientes' },
  //   options: [
  //     {
  //       label: "Pendientes",
  //       name: "pendiente",
  //       // initial: true,
  //     },
  //     {
  //       label: "Transmitido",
  //       name: "transmitido",
  //     },
  //     {
  //       label: "Retirados",
  //       name: "retirado",
  //     },
  //   ],
  // },
  // {
  //   name: "statusProforma",
  //   label: "Estado de proforma",
  //   options: [
  //     {
  //       label: "Pendientes",
  //       name: "pendiente",
  //     },
  //     {
  //       label: "Realizados",
  //       name: "realizado",
  //     },
  //   ],
  // },
  {
    name: "step",
    url: `/processstep/GetProcessStepsByProcedureTypeId/1`,
    label: "Todos los pasos",
    valueOption: "step",
    labelOption: "name",
  },
  // {
  //   name: "dateQuery",
  //   label: "Filtrar fecha por:",
  //   // defaultValue: "fechaDeFacturación",
  //   options: [
  //     {
  //       label: "Fecha de facturación",
  //       name: "fechaDeFacturación",
  //     },
  //     {
  //       label: "Fecha aceptación",
  //       name: "a2FechaDeAceptación",
  //     },
  //   ],
  // },
  // { type: "rangeDate" },
];

export const filtersRegularizationDefault = [
  {
    name: "companyId",
    url: "/company/getallcompanies",
    label: "Todas las compañías",
    valueOption: "id",
    labelOption: "razonSocial",
  },
  {
    name: "liquidator",
    url: "/Dropdown/rol_liquidator/options",
    label: "Todos los liquidadores",
    valueOption: "name",
    labelOption: "name",
    aditionalOptions: [{ label: "*NO ASIGNADOS*", value: "-" }]
  },
  // {
  //   name: "gestor",
  //   url: "/Dropdown/rol_gestor/options",
  //   label: "Todos los gestores",
  //   valueOption: "name",
  //   labelOption: "name",
  //   aditionalOptions: [{ label: "*NO ASIGNADOS*", value: "-" }]
  // },
  // {
  //   name: "inCharge",
  //   url: "/Dropdown/rol_InCharge/options",
  //   label: "Todos los encargados",
  //   valueOption: "id",
  //   labelOption: "name",
  // },
  {
    name: "inCharges",
    url: "/Dropdown/rol_InCharge/options",
    label: "Todos los encargados",
    type: "multiSelect",
    valueOption: "id",
    labelOption: "name",
  },
  // {
  //   name: "status",
  //   label: "Todos los tramites",
  //   options: [
  //     {
  //       label: "Pendientes",
  //       name: "pendiente",
  //       initial: true,
  //     },
  //     {
  //       label: "Transmitido",
  //       name: "transmitido",
  //     },
  //     {
  //       label: "Retirados",
  //       name: "retirado",
  //     },
  //   ],
  // },
  {
    name: "status",
    label: "Estado de trámites",
    type: "multiSelect",
    // defaultValue: { value: 'pendiente', label: 'Pendientes' },
    options: [
      {
        label: "Pendientes",
        name: "pendiente",
        // initial: true,
      },
      {
        label: "Transmitido",
        name: "transmitido",
      },
      {
        label: "Retirados",
        name: "retirado",
      },
      {
        label: "Concluidos",
        name: "concluido",
      },
    ],
  },
  {
    name: "statusProforma",
    label: "Estado de proforma",
    options: [
      {
        label: "Pendientes",
        name: "pendiente",
      },
      {
        label: "Realizados",
        name: "realizado",
      },
    ],
  },
  // {
  //   name: "step",
  //   url: `/processstep/GetProcessStepsByProcedureTypeId/1`,
  //   label: "Todos los pasos",
  //   valueOption: "step",
  //   labelOption: "name",
  // },
  {
    name: "dateQuery",
    label: "Filtrar fecha por:",
    // defaultValue: "fechaDeFacturación",
    options: [
      {
        label: "Fecha de facturación",
        name: "fechaDeFacturación",
      },
      {
        label: "Fecha aceptación",
        name: "a2FechaDeAceptación",
      },
    ],
  },
  { type: "rangeDate" },
];

export const addFiltersDefault = [
  {
    name: "codigoDeInterno",
    label: "Nro. Trazo",
    filter: true,
  },
  { name: "a1NúmeroDeDeclaración", label: "Nro. DIM/DEX", filter: true },
  { name: "nroDeInterno", label: "Nro. Interno", filter: true },
  // {
  //   name: "aduana",
  //   label: "Aduana",
  //   filter: true,
  // },
  // {
  //   name: "canal",
  //   label: "Canal",
  //   filter: true,
  // },
  // {
  //   name: "complejidad",
  //   label: "Complejidad",
  //   filter: true,
  // },
  // {
  //   name: "regimen",
  //   label: "Regimen",
  //   filter: true,
  // },
  // {
  //   name: "descripcionMercancia",
  //   label: "Mercadería",
  //   filter: true,
  // },
  // {
  //   name: "tipoDeMercadería",
  //   label: "Tipo de Mercadería",
  //   filter: true,
  // },
  // {
  //   name: "prioridad",
  //   label: "Prioridad",
  //   filter: true,
  // },
  // {
  //   name: "transportista",
  //   label: "Transportista",
  //   filter: true,
  // },
  // {
  //   name: "nroEmbarque",
  //   label: "Nro. de embarque",
  //   filter: true,
  // },
  // {
  //   name: "proveedor",
  //   label: "Proveedor",
  //   filter: true,
  // },
  // {
  //   name: "tarea",
  //   label: "Tarea del día",
  //   filter: true,
  // },
  // {
  //   name: "origenDelEmbarque",
  //   label: "Orígen del embarque (País)",
  //   filter: true,
  // },
  // {
  //   name: "intermediario",
  //   label: "Intermediario",
  //   filter: true,
  // },
  // {
  //   name: "aereolineas",
  //   label: "Transportadoras",
  //   filter: true,
  // },
  // {
  //   name: "agenteDeCarga",
  //   label: "Agente de carga",
  //   filter: true,
  // },
];

export const dataGeneral = [
  {
    id: 1,
    head: "Identificacion de la declaracion",
    icon: "fa-regular fa-rectangle-list",
    // type: 'table',
    items: [
      {
        id: 1,
        label: "A3 N° de referencia",
        initial: "473",
        name: "campo1",
        type: "text",
      },
      {
        id: 2,
        label: "Example",
        initial: "45",
        name: "campo2",
        type: "text",
      },
      {
        id: 3,
        label: "A3 N° de referencia",
        initial: "47fff",
        name: "campo3",
        type: "text",
      },
      {
        id: 4,
        label: "Example4",
        initial: "4544",
        name: "campo4",
        type: "text",
      },
      {
        id: 5,
        label: "A3 N° de referencia",
        initial: "473",
        name: "campo5",
        type: "text",
      },
      {
        id: 6,
        label: "Example",
        initial: "45",
        name: "campo6",
        type: "text",
      },
      {
        id: 7,
        label: "A3 N° de referencia",
        initial: "47fff",
        name: "campo7",
        type: "text",
      },
      {
        id: 8,
        label: "Example4",
        initial: "4544",
        name: "campo8",
        type: "text",
      },
      {
        id: 9,
        label: "A3 N° de referencia",
        initial: "473",
        name: "campo9",
        type: "text",
      },
      {
        id: 10,
        label: "Example",
        initial: "45",
        name: "campo10",
        type: "text",
      },
      {
        id: 11,
        label: "A3 N° de referencia",
        initial: "47fff",
        name: "campo11",
        type: "text",
      },
      {
        id: 12,
        label: "Example4",
        initial: "4544",
        name: "campo12",
        type: "text",
      },
      {
        id: 13,
        label: "A3 N° de referencia",
        initial: "47fff",
        name: "campo13",
        type: "text",
      },
      {
        id: 14,
        label: "Example4",
        initial: "4544",
        name: "campo14",
        type: "text",
      },
    ],
  },
  {
    id: 2,
    head: "Operadores",
    icon: "",
    items: [
      {
        id: 1,
        label: "A3 Aduana",
        initial: "473",
        name: "campo1",
        type: "text",
      },
    ],
  },
  {
    id: 3,
    head: "Lugares",
    icon: "",
    items: [
      {
        id: 1,
        label: "A3 Destino",
        initial: "473",
        name: "campo1",
        type: "text",
      },
    ],
  },
  {
    id: 4,
    head: "Transporte",
    icon: "",
    type: "list",
    items: [
      {
        id: 1,
        label: "A3 Transporte",
        initial: "473",
        name: "campo1",
        type: "text",
      },
      {
        id: 2,
        label: "Example",
        initial: "45",
        name: "campo2",
        type: "text",
      },
      {
        id: 3,
        label: "A3 N° de referencia",
        initial: "47fff",
        name: "campo3",
        type: "text",
      },
      {
        id: 4,
        label: "Example4",
        initial: "4544",
        name: "campo4",
        type: "text",
      },
    ],
  },
];
export const dataGeneral2 = [
  {
    id: 1,
    head: "Identificacion de la declaracion",
    icon: "",
    items: [
      {
        id: 1,
        label: "A3 N° de referencia",
        initial: "473",
        name: "campo1",
        type: "text",
      },
      {
        id: 2,
        label: "Example",
        initial: "473",
        name: "campo1",
        type: "text",
      },
    ],
  },
];
export const dataGeneral3 = [
  {
    id: 1,
    head: "Identificacion de la declaracion",
    icon: "",
    items: [
      {
        id: 1,
        label: "A3 N° de referencia",
        initial: "473",
        name: "campo1",
        type: "text",
      },
      {
        id: 2,
        label: "Example",
        initial: "473",
        name: "campo1",
        type: "text",
      },
    ],
  },
];

export const monthList = [
  {
    id: 1,
    label: "enero",
    name: "-01-",
    color: "rgb(58,182,229)",
  },
  {
    id: 2,
    label: "febrero",
    name: "-02-",
    color: "rgb(53,184,193)",
  },
  {
    id: 3,
    label: "marzo",
    name: "-03-",
    color: "rgb(205,222,151)",
  },
  {
    id: 4,
    label: "abril",
    name: "-04-",
    color: "rgb(180,212,104)",
  },
  {
    id: 5,
    label: "mayo",
    name: "-05-",
    color: "rgb(128,186,53)",
  },
  {
    id: 6,
    label: "junio",
    name: "-06-",
    color: "rgb(254,223,0)",
  },
  {
    id: 7,
    label: "julio",
    name: "-07-",
    color: "rgb(233,78,22)",
  },
  {
    id: 8,
    label: "agosto",
    name: "-08-",
    color: "rgb(230,39,35)",
  },
  {
    id: 9,
    label: "septiembre",
    name: "-09-",
    color: "rgb(248,201,76)",
  },
  {
    id: 10,
    label: "octubre",
    name: "-10-",
    color: "rgb(248,161,81)",
  },
  {
    id: 11,
    label: "noviembre",
    name: "-11-",
    color: "rgb(225,123,46)",
  },
  {
    id: 12,
    label: "diciembre",
    name: "-12-",
    color: "rgb(172,223,251)",
  },
];

export const chartColors = () => {
  return [
    "rgb(75, 192, 192)",
    "rgb(255, 99, 132)",
    "rgb(255, 205, 86)",
    "rgb(54, 162, 235)",
    "rgb(153, 102, 255)",
    "rgb(255, 159, 64)",
    "rgb(141, 180, 226)",
    "rgb(255, 165, 0)",
    "rgb(0, 255, 255)",
    "rgb(255, 0, 255)",
    "rgb(255, 105, 180)",
    "rgb(34, 193, 195)",
    "rgb(253, 187, 45)",
    "rgb(75, 0, 130)",
    "rgb(0, 128, 128)",
    "rgb(255, 20, 147)"
  ]
}

export const ProformParameters = () => {
  return {
    transporteLocal: {
      aereo: {
        peso: {
          'MINIMA': 80,
          'NORMAL': 120,
          'MEDIO': 150,
          'ALTO': 250,
          'MUY ALTO': 350
        },
        distancia: {
          'NORMAL': 0,
          'MEDIA': 30,
          'LEJANA': 50,
          'MUY LEJANA': 80
        },
        sobredimension: {
          'NORMAL': 0,
          'SD (A) 1': 50,
          'SD (A) 2': 100,
          'SD (A) 3': 150,
          'SD (A) 4': 200,
        },
      },
      terrestreMultimodal: {
        peso: {
          'MINIMA': 150,
          'NORMAL': 250,
          'MEDIO': 350,
          'ALTO': 450,
          'MUY ALTO': 550,
        },
        distancia: {
          'NORMAL': 0,
          'MEDIA': 50,
          'LEJANA': 100,
          'MUY LEJANA': 150,
        },
        sobredimension: {
          'NORMAL': 0,
          'SD (A) 1': 50,
          'SD (A) 2': 100,
          'SD (A) 3': 150,
          'SD (A) 4': 200,
        }
      },
    },
    gestionesSenasag: {
      'INSPECCION SENASAG': 80,
      'PERMISO DE IMPORTACION DE MUESTRAS': 350,
      'NINGUNO': 0,
    },
    tipoDespacho: {
      'AEREO': 2,
      'TERRESTRE/MULTIMODAL': null,
    },
    estibaje: {
      dificultad: {
        'NORMAL': 0.00,
        'MEDIA': 30.00,
        'ALTA': 50.00,
        'MUY ALTA': 80.00,
      },
      cantidad: {
        '0': 0.00,
        '1': 50.00,
        '2': 100.00,
        '3': 150.00,
        '4': 200.00,
        '5': 250.00,
        '6': 300.00,
      }
    },
    transportadoras: [
      {
        label: 'UPS PRE-PAID 250',
        amount: 250,
      },
      {
        label: 'UPS PRE-PAID 350',
        amount: 350,
      },
      {
        label: 'UPS PRE-PAID 450',
        amount: 450,
      },
      {
        label: 'UPS PRE-PAID 550',
        amount: 550,
      },
      {
        label: 'DHL COURIER',
        amount: 600,
      },
      {
        label: 'AMERICAN AIRLINES  (TAB)',
        amount: 150,
      },
      {
        label: 'KLM CARGO  (TAB)',
        amount: 150,
      },
      {
        label: 'MERCURY AMERICAS (TAB)',
        amount: 250,
      },
      {
        label: 'SAC SOUTH AMERICAN AIRWAYS (TAB)',
        amount: 250,
      },
      {
        label: 'TACA (AEROALAS)',
        amount: 350,
      },
      {
        label: 'UPS AIR CARGO (AEROALAS)',
        amount: 350,
      },
      {
        label: 'LACSA AIRLINES DE COSTA RICA (AEROALAS)',
        amount: 700,
      },
      {
        label: 'JET CLUB (AEROALAS)',
        amount: 700,
      },
      {
        label: 'CONDOR  FLUGDIENST(AEROALAS)',
        amount: 700,
      },
      {
        label: 'AEROLINEAS ARGENTINAS (BOA CARGO)	139',
        amount: 2,
      },
      {
        label: 'TAP AIR PORTUGAL (BOA CARGO)	139',
        amount: 2,
      },
      {
        label: 'EXPO AVIATION (BOA CARGO)	208',
        amount: 8,
      },
      {
        label: 'BRINGER AIR CARGO (BOA CARGO)	208',
        amount: 8,
      },
      {
        label: 'AEROLINEAS DE MAGADAN (BOA CARGO)	278',
        amount: 4,
      },
      {
        label: 'AIRCLASS LINEAS AEREAS (BOA CARGO)	278',
        amount: 4,
      },
      {
        label: 'ALLIED AIR (BOA CARGO)',
        amount: 350,
      },
      {
        label: 'AIR EUROPA (INTER AIR CARGO)',
        amount: 350,
      },
      {
        label: 'AEROLINEAS ARGENTINAS (AERO CARIBE)',
        amount: 350,
      },
      {
        label: 'BAHAMASAIR (AERO CARIBE)',
        amount: 700,
      },
      {
        label: 'AEROLINEAS DEL IMPERIO (AERO CARIBE)',
        amount: 1150,
      },
      {
        label: 'COMPAÑÍA AEREA DOMODEDOVO  (AERO CARIBE)',
        amount: 1400,
      },
      {
        label: 'TUI AIRLINES (AERO CARIBE)',
        amount: 1400,
      },
      {
        label: 'LAN CHILE CARGO (LATAM)	417',
        amount: 6,
      },
      {
        label: 'LATAM CARGO BRASIL (LATAM)	417',
        amount: 6,
      },
      {
        label: 'SRILANKAN CARGO (LATAM)	417',
        amount: 6,
      },
      {
        label: 'GOL (PFS)',
        amount: 350,
      },
      {
        label: 'AVIANCA (PFS)',
        amount: 350,
      },
      {
        label: 'NINGUNO',
        amount: 0,
      },
      {
        label: 'UPS FD',
        amount: 0,
      },
      {
        label: 'TAB AIRLINES-150',
        amount: 150,
      },
      {
        label: 'TAB AIRLINES-250',
        amount: 250,
      },
      {
        label: 'PROFIT CARGO (UPS CARGO)',
        amount: 550,
      },
    ],
    comisionAgencia: [
      {
        init: 1,
        fin: 10000,
        percentage: 2,
      },
      {
        init: 10001,
        fin: 30000,
        percentage: 1.5,
      },
      {
        init: 30001,
        fin: 50000,
        percentage: 1,
      },
      {
        init: 50001,
        fin: 100000,
        percentage: 0.75,
      },
      {
        init: 100001,
        // fin: 100000,
        percentage: 0.5,
      },
    ],
    items: [
      { init: 1, fin: 5, gastosDespacho: 400, fdm: 150, dav: 550, dam: 350, sicoin: 0, exPrevio: 100 },
      { init: 6, fin: 10, gastosDespacho: 450, fdm: 200, dav: 550, dam: 350, sicoin: 0, exPrevio: 150 },
      { init: 11, fin: 20, gastosDespacho: 500, fdm: 250, dav: 650, dam: 400, sicoin: 0, exPrevio: 200 },
      { init: 21, fin: 30, gastosDespacho: 550, fdm: 300, dav: 750, dam: 400, sicoin: 0, exPrevio: 200 },
      { init: 30, fin: 40, gastosDespacho: 600, fdm: 350, dav: 850, dam: 400, sicoin: 0, exPrevio: 250 },
      { init: 41, fin: 50, gastosDespacho: 650, fdm: 450, dav: 950, dam: 400, sicoin: 0, exPrevio: 300 },
      { init: 51, fin: null, gastosDespacho: 700, fdm: 500, dav: 950, dam: 400, sicoin: 0, exPrevio: 350 },
    ],
    // },
    bSelected: [],
    cSelected: [],
    dSelected: [],
  }
}

export const defaultFormatTableFormDocs = { "fields": [{ "name": "order", "label": "#", "type": "number", "typeInput": "number", "rols": [], "formConfig": true, "tableConfig": true }, { "name": "label", "label": "Documento", "placeholder": "", "typeInput": "text", "rols": [], "formConfig": false, "tableConfig": true }, { "name": "description", "label": "Url de Archivo", "placeholder": "", "typeInput": "text", "rols": [], "formConfig": true, "tableConfig": false }, { "label": "Archivo", "name": "descriptionRef", "type": "file", "typeInput": "file", "rols": [], "formConfig": true, "tableConfig": false }, { "label": "Recibo", "name": "recibo", "type": "checkbox", "typeInput": "checkButton", "rols": [], "formConfig": true, "tableConfig": true }, { "name": "description2", "label": "Número", "placeholder": "", "typeInput": "text", "rols": [], "formConfig": true, "tableConfig": true }, { "name": "description3", "label": "Proveedor", "placeholder": "", "typeInput": "selectNewOption", "urlApi": "/dropdown/providers/options", "value": "name", "labelOption": "name", "rols": [], "formConfig": true, "tableConfig": true }, { "name": "description5", "label": "Estado", "typeInput": "select", "placeholder": "", "urlApi": "/dropdown/estados/options", "drpList": "estados", "value": "name", "labelOption": "name", "rols": [], "formConfig": true, "tableConfig": true }, { "name": "det_presentation", "label": "Presentación", "typeInput": "select", "placeholder": "", "urlApi": "/dropdown/presentacion/options", "drpList": "presentacion", "value": "name", "labelOption": "name", "rols": [], "formConfig": true, "tableConfig": true }, { "name": "description4", "label": "Monto", "placeholder": "", "typeInput": "text", "rols": [], "formConfig": true, "tableConfig": true }, { "name": "endDate", "label": "Fecha de emisión", "placeholder": "", "type": "date", "typeInput": "date", "dateFormat": "DD/MM/YYYY", "rols": [], "formConfig": true, "tableConfig": true }, { "name": "observation", "label": "Descripción", "placeholder": "0", "typeInput": "text", "rols": [], "formConfig": true, "tableConfig": true }], "changeStatus": [], "openUrl": "description", "buttons": "edit,create,delete" }